/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
export function applyTransformOnKeys<T>(
  keys: readonly string[],
  transform: (value: T[keyof T]) => any
) {
  return function recurse(obj: any): any {
    if (!obj) {
      return obj;
    }
    const keySet = new Set(keys);
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (keySet.has(key)) {
        // @ts-ignore
        acc[key] = transform(value);
      } else if (typeof value === 'object') {
        // @ts-ignore
        acc[key] = recurse(value);
      } else {
        // @ts-ignore
        acc[key] = value;
      }

      return acc;
    }, {} as T);
  };
}

/*
 * Performs right-to-left function composition.
 * The last argument may have any arity; the remaining arguments must be unary.
 */
export function compose(...functions: ((...args: any[]) => any)[]) {
  return function composed(...args: any[]) {
    if (functions.length === 0) {
      return args;
    }

    const firstResult = functions[functions.length - 1](...args);
    return functions
      .slice(0, -1)
      .reduceRight((acc, func) => func(acc), firstResult);
  };
}
